// extracted by mini-css-extract-plugin
module.exports = {"emptyCell":"List_emptyCell__1Wfxm"};